module.exports = __webpack_public_path__ + "img/asset.7d8e7424.svg";